/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Metrics_Cps_UnitInputs */



/**
* | output |
* | --- |
* | "cps" |
*
* @param {Event_Metrics_Cps_UnitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_cps_unit = /** @type {((inputs?: Event_Metrics_Cps_UnitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Cps_UnitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("cps")
	if (locale === "de") return /** @type {LocalizedString} */ ("cps")
	if (locale === "it") return /** @type {LocalizedString} */ ("cps")
	if (locale === "ru") return /** @type {LocalizedString} */ ("цпс")
	if (locale === "es") return /** @type {LocalizedString} */ ("cps")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("cps")
	if (locale === "ja") return /** @type {LocalizedString} */ ("cps")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सीपी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("cps")
	return /** @type {LocalizedString} */ ("cps")
});